import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { GlobalSettings } from './environments/global-settings';

const loadConfig = async () => {
  const url = `${environment.odooUrl}/store/webshop_configuration`;

  const configurationResponse = await fetch(url, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: '{}'
  });
  return await configurationResponse.json();
};

const assignNonNullAndEmptyValues = (target, source) => {
  if (target == null || source == null) {
    return;
  }

  for (const key in source) {
    if (source[key] !== null && source[key] !== undefined && source[key] !== '' && source[key]) {
      target[key] = source[key];
    }
  }
};

const updateEnvironment = (configuration: any) => {
  if (!configuration) {
    return;
  }

  assignNonNullAndEmptyValues(environment, configuration);
};

const main = async () => {

  try {
    const { origin } = window.location;
    environment.odooUrl = origin;

    const configuration = await loadConfig();
    updateEnvironment(configuration);
  }
  catch (error) {
    console.error(error);
  }

  environment.globalSettings = new GlobalSettings();

  if (environment.production) {
    enableProdMode();
  }

  const favIcon = document.createElement('link');
  favIcon.href = environment.faviconUrl ? environment.faviconUrl : '/store/theme/favicon.ico';
  favIcon.type = 'image/x-icon';
  favIcon.rel = 'icon';

  const styleLocation = document.createElement('link');
  styleLocation.href = environment.linkLocationCSS ? environment.linkLocationCSS : 'static/css/main_styles.css';
  styleLocation.type = 'text/css';
  styleLocation.rel = 'stylesheet';

  document.title = environment.title || 'Web Shop';

  setTimeout(() => {
    document.head.appendChild(favIcon);
    document.head.appendChild(styleLocation);
  }, 1);

  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.log(err));
};

main().then(
  text => {
    console.log(text);
  },
  err => {
    console.error(err);
  }
);
